import React from 'react';
import styles from './StatusBox.scss';

const StatusBox = props => {
  return (
    <div className={styles.custom_io}>
      <h3>{props.title}</h3>
      <textarea
        className={`${styles.custom_io_body} ${
          props.error ? styles['c-custom-input__output--errors'] : ''
        }`}
        rows="4"
        cols="50"
        onChange={event => props.onChange(event.target.value)}
        value={props.value}
        readOnly={props.readOnly}
      />
      {props.children}
    </div>
  );
};

export default StatusBox;
